import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);

// Bump this when the default theme changes to force a reset for existing users
const THEME_VERSION = "v2-light-default";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    const savedVersion = localStorage.getItem("sdm_theme_version");
    if (savedVersion !== THEME_VERSION) {
      // Migration: reset any previous theme to the new default
      localStorage.setItem("sdm_theme_version", THEME_VERSION);
      localStorage.setItem("sdm_theme", "light");
      return "light";
    }
    return localStorage.getItem("sdm_theme") || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("sdm_theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <Ctx.Provider value={{ theme, toggle, setTheme }}>{children}</Ctx.Provider>;
}
export const useTheme = () => useContext(Ctx);
